import { Component, OnInit } from '@angular/core';
import { TramitesService } from 'src/app/servicios/tramites.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Loading } from 'src/app/Class/Loading';
declare var $:any;


@Component({
  selector: 'app-detalle-tramite-pb',
  templateUrl: './detalle-tramite-pb.component.html',
  styleUrls: ['./detalle-tramite-pb.component.css']
})
export class DetalleTramitePbComponent implements OnInit {
  public id: number;
  public tramite: any = [];
  public historial: any = [];
  public serve : any;
  public estados: any = [];
  public estadosSelect: any = [];
  
  
  constructor(private tramiteService: TramitesService,  private rout: ActivatedRoute, private route: Router, private form: FormBuilder, public loading: Loading) { 
   
    this.loading.estado = true;

    this.rout.params.subscribe(params => { this.id = params['id']; });
   
    this.serve = this.tramiteService.getServe();
   
    this.tramiteService.getDetalle(this.id).subscribe(data => {
      if(data['success']){
        this.tramite  = data['data']['tramite'];
        this.historial = data['data']['historial'];
        this.estados = data['data']['estados'];
      }
      else{
        Swal.fire({
          type: 'error',
          title:'Error',
          text: 'Trámite no disponible',
          showConfirmButton: false,
          timer: 1500
        });     
        this.route.navigate(['/dashboard']);
      }
      this.loading.estado = false;
    });
  }

  ngOnInit() {
  }   
}
